import { Component, HostBinding, Input, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { generateImageSrc, normalizeWebAction } from '@box/utils';
import { PromoBanner } from '@box-types';
import { Router } from '@angular/router';

@Component({
  selector: 'landing-promo-banner',
  templateUrl: './landing-promo-banner.component.html',
  styleUrls: ['./landing-promo-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingPromoBannerComponent implements OnInit {
  @Input() public promoBanner: PromoBanner;

  public isOpen: boolean;
  public title: string;
  public imageSrc: string;
  public description: string;
  public isClickable: boolean;

  constructor(private router: Router, private changeDetectorRef: ChangeDetectorRef) {}

  @HostBinding('class') public hostClass = 'landing-promo-banner';

  ngOnInit(): void {
    this.title = this.promoBanner.detailsTitle;
    this.imageSrc = generateImageSrc(this.promoBanner.webImage);
    this.isOpen = true;
    this.isClickable = Boolean(this.promoBanner?.webLandingAction);
  }

  public toggle(): void {
    this.isOpen = !this.isOpen;
    this.changeDetectorRef.detectChanges();
  }

  public onClickDetails(): void {
    if (!this.isClickable) return;
    const webLandingAction = this.promoBanner?.webLandingAction;
    const navigationUrl = normalizeWebAction(webLandingAction);
    return void this.router.navigateByUrl(navigationUrl);
  }
}
